/**
 * Team Filter App
 * Provides filterable team member display with location and department filters
 */

import { createApp } from 'vue';
import TeamFilter from './components/TeamFilter.vue';

// Initialize Team Filter when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	const teamFilterContainer = document.getElementById('team-filter-app');

	if (teamFilterContainer) {
		// Create and mount the Vue app
		const app = createApp(TeamFilter);

		// Make WordPress data available to Vue
		app.config.globalProperties.$wordpress = {
			ajaxUrl: window.jaeckleData?.ajaxUrl || '/wp-admin/admin-ajax.php',
			nonce: window.jaeckleData?.nonce || '',
			siteUrl: window.jaeckleData?.siteUrl || '',
		};

		app.mount('#team-filter-app');
	}
});
